export default "__VITE_ASSET__DKVFFulm__"